import { render, staticRenderFns } from "./NotesTable.vue?vue&type=template&id=04c30848&scoped=true"
import script from "./NotesTable.vue?vue&type=script&lang=js"
export * from "./NotesTable.vue?vue&type=script&lang=js"
import style0 from "./NotesTable.vue?vue&type=style&index=0&id=04c30848&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c30848",
  null
  
)

export default component.exports